import { useState, useCallback, useRef, useEffect } from "react";
import { postRoleCheck } from "../../../assets/nodeApi/postApi/postSchoolApi";

const DEBOUNCE_MS = 500;

const useRoleCheck = () => {
  const [roleData,   setRoleData]   = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const [roleError,  setRoleError]  = useState(null);

  const debounceTimer  = useRef(null);
  const lastCheckedRef = useRef("");

  const checkRole = useCallback(async (identifier) => {
    const trimmed = identifier?.trim();
    if (!trimmed || trimmed === lastCheckedRef.current) return;
    lastCheckedRef.current = trimmed;

    setIsChecking(true);
    setRoleError(null);
    setRoleData(null);

    try {
      const response = await postRoleCheck(trimmed);

      // axios: response.data = { success, role, data: { ...user } }
      
      const payload  = response?.data;
      
      const userData = payload;
      const role     = userData?.role;  // 👈 "publisher_sme" | "student" | "teacher" | "school"
        
      if (userData) {
        setRoleData({ role, user: userData });
      } else {
        setRoleError("User not found");
      }
    } catch (err) {
      const message =
        err.response?.data?.error   ||
        err.response?.data?.message ||
        "User not found";
      setRoleError(message);
    } finally {
      setIsChecking(false);
    }
  }, []);

  const onUsernameChange = useCallback((identifier) => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      checkRole(identifier);
    }, DEBOUNCE_MS);
  }, [checkRole]);

  const resetRoleCheck = useCallback(() => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    lastCheckedRef.current = "";
    setRoleData(null);
    setRoleError(null);
    setIsChecking(false);
  }, []);

  useEffect(() => () => clearTimeout(debounceTimer.current), []);

  return { onUsernameChange, resetRoleCheck, isChecking, roleData, roleError };
};

export default useRoleCheck;